import { SvgIcon } from '@bob/library'
import { LocaleUrl } from '@websrc/Build/Pages/buildTypes'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { box, resetList, styles, typography } from 'leds'
import React, { Fragment } from 'react'

import { WithBrand } from './WithBrand'

export interface BreadcrumbProps {
  items: {
    label: string
    url?: LocaleUrl
    withBrand?: boolean
  }[]
}

export const Breadcrumbs = ({ items }: BreadcrumbProps) => (
  <ol
    className={clsx(
      resetList,
      styles({
        display: 'flex',
        alignItems: 'center',
        paddingY: 20,
        maxWidth: 650,
      }),
      typography({ color: 'grey', size: 'md' })
    )}
  >
    <li aria-hidden={true} className={styles({ paddingRight: 16 })}>
      <div
        className={box({
          type: 'icon',
          border: 'full',
          borderColor: 'grey5',
          rounded: 'small',
          background: 'white',
        })}
      >
        <SvgIcon color={'grey9'} name={'HOME'} size={20} />
      </div>
    </li>
    {items.map((item, key) => (
      <Fragment key={key}>
        <li className={styles({ position: 'relative' })}>
          <span
            className={clsx(
              styles({ position: 'absolute', bottom: 'full', left: 0 }),
              typography({ size: 'xs', color: 'grey', lineHeightReset: true })
            )}
          >
            {item.withBrand && <WithBrand title={'{brand}'} />}
          </span>
          {item.url ? (
            <Link
              className={typography({ color: 'blue', size: 'md', weight: 'bold' })}
              to={item.url}
            >
              {item.label}
            </Link>
          ) : (
            <span>{item.label}</span>
          )}
        </li>
        {key < items.length - 1 && (
          <li aria-hidden={true} className={styles({ paddingX: 16 })}>
            /
          </li>
        )}
      </Fragment>
    ))}
  </ol>
)
